// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","826":"index"}[chunkId] + "." + {"535":"a1d1be44","826":"8e601f71"}[chunkId] + ".css";
};